module.exports = {
    Component     : require('./component')
  , AbstractModel : require('./abstract-model')
  , Xyz           : require('./xyz')
  , Rgb           : require('./rgb')
  , HexRgb        : require('./hex-rgb')
  , Lab           : require('./lab')
  , Hsl           : require('./hsl')
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/color-model/lib/index.js
// module id = 3dXu
// module chunks = 11